import React, { useEffect, useState } from "react";
import api from "../api/axios";
import TransactionForm from "../components/forms/TransactionForm";
import VoucherDetails from "../components/modal/VoucherDetails";

function Transaction() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [filters, setFilters] = useState({
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 2)
                .toISOString()
                .split("T")[0],
      endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
              .toISOString()
              .split("T")[0],
    });

  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
        ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
        : 0;

  // Fetch entries
  const fetchEntries = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const { startDate, endDate } = filters;
      const res = await api.get(`/entry-list?page=${pageNumber}&branch_id=${branch_id}&from=${startDate}&to=${endDate}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setEntries(res.data.data.data);
      setPage(res.data.data.current_page);
      setLastPage(res.data.data.last_page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, []);  

  // Close Modal → reset form on next open
  const handleCloseModal = () => {
    window.closePanel();
    setSelectedEntry(null);
  };

  const handleFormSubmit = async (formData, entryId = null) => {
    setErrorMsg("");
    try {
      formData.branch_id = branch_id;

      let url = "";
      let method = "";

      if (entryId) {
        url = `/update-transaction/${entryId}`;
        method = "put";
      } else {
        url = "/store-transaction";
        method = "post";
      }

      const res = await api({
        url: url,
        method: method,
        data: formData,
        headers: { Authorization: `Bearer ${token}` },
      });

      /* const res = await api.post("/store-transaction", formData, {
        headers: { Authorization: `Bearer ${token}` },
      }); */
      setSuccessMsg(res.data.message || "Entry saved successfully.");
      setTimeout(() => setSuccessMsg(""), 3000);
      fetchEntries(page);
      handleCloseModal();
  } catch (err) {
    console.error(err);
    let msg = "Failed to save entry. Please check the fields.";
    if (err.response?.data?.message) {
      msg = err.response.data.message;
    }
    setErrorMsg(msg); 
  }
};

// Handle filter changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

// Apply filters
const handleApplyFilters = () => {
  fetchEntries(1);
};

// Reset filters
const handleResetFilters = () => {
  setFilters({
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 2)
                .toISOString()
                .split("T")[0],
    endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
              .toISOString()
              .split("T")[0],
  });
};

  return (
    <>
      {/* Page Title */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">General Journal Entry</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a href="#">Accounts</a>
                </li>
                <li className="breadcrumb-item active">General Journal Entry</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {successMsg && (
        <div className="alert alert-success">
          {successMsg}
        </div>
      )}

      {/* List */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">Journal List</h5>

            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={() =>
                window.openPanel("New Journal Entry", <TransactionForm onSubmit={handleFormSubmit} />)
              }
            >
              + Add
            </button>
          </div>

          <div className="card-body">
            {/* Filters */}
                  <div className="row mb-3">
                    <div className="col-md-2">
                    <input
                      type="date"
                      className="form-control"
                      id="startDate"
                      name="startDate"
                      value={filters.startDate}
                      onChange={handleFilterChange}
                    />
                    </div>
                    <div className="col-md-2">
                    <input
                      type="date"
                      className="form-control"
                      id="endDate"
                      name="endDate"
                      value={filters.endDate}
                      onChange={handleFilterChange}
                    />
                    </div>

                    <div className="col-md-2 d-flex align-items-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleApplyFilters}
                    >
                      Load
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={handleResetFilters}
                    >
                      Reset
                    </button>
                    </div>

                  </div>

                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <div className="table-responsive">
                    <table className="table table-bordered transaction-table">
                      <thead>
                      <tr>
                        <th>Reference No.</th>
                        <th>Voucher No.</th>
                        <th>Date</th>
                        <th>Description</th>
                        <th className="text-end">Amount</th>
                        <th className="text-center">Actions</th>
                      </tr>
                      </thead>

                      <tbody>
                      {entries.length > 0 ? (
                        entries.map((entry, index) => (
                        <tr key={entry.id}>

                          <td width="10%">
                          <span
                            className="voucher-link"
                            onClick={() =>
                            window.openPanel(
                              "Journal Entry Details",
                              <VoucherDetails
                                  voucherId={entry.id}
                                  startDate={filters.startDate}
                                  endDate={filters.endDate}
                              />
                            )
                            }
                          >
                            {entry.series_no}
                          </span>
                          </td>

                          <td width="10%">
                          <span
                            className="voucher-link"
                            onClick={() =>
                            window.openPanel(
                              "Journal Entry Details",
                              <VoucherDetails
                              voucherId={entry.id}
                              startDate={filters.startDate}
                              endDate={filters.endDate}
                              />
                            )
                            }
                          >
                            {entry.voucher_no}
                          </span>
                          </td>

                          <td width="10%">{new Date(entry.voucher_date).toLocaleDateString("en-GB")}</td>
                          <td width="50%">{entry.narration}</td>
                          <td className="text-end">
                          {parseFloat(entry.amount).toFixed(2)}
                          </td>
                          <td className="text-center">
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() =>
                            window.openPanel(
                              "Update Entry",
                              <TransactionForm
                              entry={entry}
                              onSubmit={(data) => handleFormSubmit(data, entry.id)}
                              />
                            )
                            }
                          >
                            Edit
                          </button>
                          </td>
                        </tr>
                        ))
                      ) : (
                        <tr>
                        <td colSpan="6" className="text-center text-danger">
                          No entries found
                        </td>
                        </tr>
                      )}
                      </tbody>
                    </table>
                    </div>
                  )}

                  {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => fetchEntries(page - 1)}
                  disabled={page <= 1}
                >
                  Prev
                </button>

                <span>
                  Page {page} of {lastPage}
                </span>

                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => fetchEntries(page + 1)}
                  disabled={page >= lastPage}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Transaction;